import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Layer, DnvFeatureLayer } from 'dnv-lib';

@Injectable()
export class LayersService {

  headers: any;
  error: any;
  httpOptions = {
    headers: new HttpHeaders({
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache'
    })
  };

  readonly layersUrl = 'api/layers/';

  constructor(
    private httpClient: HttpClient
  ) {
  }

  getLayers(): Observable<Layer[]> {
    return this.httpClient
      .get<Layer[]>(this.layersUrl + 'layers', this.httpOptions);
  }

  // tslint:disable-next-line: max-line-length
  // https://geotoolsprod.cdnv.dnv.ca:6443/arcgis/rest/services/Features_Infrastructure/MapServer/18/query?outFields=%2A&f=json&where=1%3D1&returnDistinctValues=false&returnGeometry=true&spatialRel=esriSpatialRelIntersects
  getGridSelectLayer(dnvFeatureLayer: DnvFeatureLayer): Observable<any> {
    return this.httpClient
      .get<any>(
        dnvFeatureLayer.url +
        '/query?outFields=%2A&f=json&where=' + dnvFeatureLayer.whereClause +
        '&returnDistinctValues=false&returnGeometry=true&spatialRel=esriSpatialRelIntersects'
        , this.httpOptions);
  }

}

